export default __webpack_public_path__ + "static/media/cuisinePositive.c4df47c2.webp";